import {Pipe, PipeTransform} from '@angular/core';
import { decrypt } from '../encryptHelper';
@Pipe({
    name: 'decrypt'
})


export class DecryptPipe implements PipeTransform {
    transform(value: string) {
        if(!value || typeof value!== 'string'){
            return value;
        }
        return decrypt(value);
    }
}
